export default __webpack_public_path__ + "./img/street_lighting.png";